var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var CustomValidationRenderer = /** @class */ (function () {
    function CustomValidationRenderer() {
    }
    CustomValidationRenderer.prototype.render = function (instruction) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
        var _this = this;
        try {
            for (var _e = __values(instruction.unrender), _f = _e.next(); !_f.done; _f = _e.next()) {
                var _g = _f.value, result = _g.result, elements = _g.elements;
                try {
                    for (var elements_1 = (e_2 = void 0, __values(elements)), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
                        var element = elements_1_1.value;
                        this.remove(element, result);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (elements_1_1 && !elements_1_1.done && (_b = elements_1.return)) _b.call(elements_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _h = __values(instruction.render), _j = _h.next(); !_j.done; _j = _h.next()) {
                var _k = _j.value, result = _k.result, elements = _k.elements;
                if (!result.valid) {
                    try {
                        for (var elements_2 = (e_4 = void 0, __values(elements)), elements_2_1 = elements_2.next(); !elements_2_1.done; elements_2_1 = elements_2.next()) {
                            var element = elements_2_1.value;
                            this.add(element, result);
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (elements_2_1 && !elements_2_1.done && (_d = elements_2.return)) _d.call(elements_2);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var notValid = instruction.render.filter(function (x) { return !x.result.valid; });
        if (notValid.length > 0) {
            var elements_3 = [];
            notValid.forEach(function (x) { return elements_3 = elements_3.concat(x.elements); });
            var sorted = elements_3.filter(function (x) { return x.offsetHeight > 0; }).sort(function (x, y) { return _this.sort(x, y); });
            var elementToScrollTo = sorted[0];
            if ($(elementToScrollTo)["scrollintoview"]) {
                $(elementToScrollTo)["scrollintoview"]({ duration: 100 });
            }
        }
    };
    CustomValidationRenderer.prototype.sort = function (element1, element2) {
        var areEqual = element1.offsetLeft === element2.offsetLeft && element1.offsetTop === element2.offsetTop;
        if (areEqual) {
            return 0;
        }
        else {
            var response = element1.offsetTop == element2.offsetTop ?
                element1.offsetLeft > element2.offsetLeft :
                element1.offsetTop > element2.offsetTop;
            return response ? 1 : -1;
        }
    };
    CustomValidationRenderer.prototype.add = function (element, error) {
        var self = this;
        if (element.classList.contains("has-error")) {
            return;
        }
        element.classList.add("has-error");
        element.classList.add("error-validation");
        var label = $("<label>").addClass("error").text(error.message);
        var children = $(element).children();
        if (children.length > 0) {
            $($(element).children().last()).append(label);
        }
        else {
            $(element).after(label);
        }
        if (element.tagName == "TEXT-BOX") {
            element.addEventListener('textchange', function () {
                self.remove(element, error);
            });
        }
        $(element)
            .find("input")
            .one("focus", function () {
            self.remove(element, error);
        });
        $(element)
            .find("input")
            .one("change", function () {
            self.remove(element, error);
        });
    };
    CustomValidationRenderer.prototype.remove = function (element, error) {
        var label = $(element).find(".error");
        if (label && label.length == 0) {
            label = $(element).siblings('.error');
        }
        if (label) {
            label.remove();
        }
        element.classList.remove("has-error");
        element.classList.remove("error-validation");
    };
    return CustomValidationRenderer;
}());
export { CustomValidationRenderer };
